import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { WhoIsItFor } from './components/WhoIsItFor';
import { SystemFeatures } from './components/SystemFeatures';
import { TomosAccordion } from './components/TomosAccordion';
import { Bonuses } from './components/Bonuses';
import { CostComparison } from './components/CostComparison';
import { Pricing } from './components/Pricing';
import { MasterKitExplanation } from './components/MasterKitExplanation';
import { MasterKitIncludes } from './components/MasterKitIncludes';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '955936987240470';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (!w.fbq) {
      ;
      (function (f: any, b: Document, e: string, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(w, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      w.fbq('init', META_PIXEL_ID);
    }
    w.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-gray-900 selection:bg-brand-orange/30" data-id="element-0">
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" />
      </noscript>
      <Hero data-id="element-3" />
      <Testimonials data-id="element-4" />
      <PainPoints data-id="element-5" />
      <WhoIsItFor data-id="element-6" />
      <SystemFeatures data-id="element-7" />
      <TomosAccordion data-id="element-8" />
      <Bonuses data-id="element-9" />
      <CostComparison data-id="element-10" />
      <Pricing data-id="element-11" />
      <MasterKitExplanation data-id="element-12" />
      <MasterKitIncludes data-id="element-13" />
      <Guarantee data-id="element-14" />
      <FAQ data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}